import { create } from "zustand";
import type { SellerStore } from "@/api/types";

/** Which of the viewer's stores the dashboard shows (plan §16.2: a Person may own several, with a switcher). */
interface DashboardStoreSelection {
  slug: string | null;
  select: (slug: string) => void;
}

export const useDashboardStoreSelection = create<DashboardStoreSelection>((set) => ({
  slug: null,
  select: (slug) => set({ slug }),
}));

/** The chosen store when it's still in the list, otherwise the first live store, otherwise the first store. */
export function pickDashboardStore(stores: readonly SellerStore[], slug: string | null): SellerStore | undefined {
  return (
    stores.find((store) => store.slug === slug) ??
    stores.find((store) => store.status === "active") ??
    stores[0]
  );
}
